import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

const firsts = [
  {
    num: "01",
    tag: "First",
    title: "First Major Production Credit",
    sub: "Ginuwine… the Bachelor · 1996",
    body: "Timbaland's first full production credit was on Ginuwine's debut album, Ginuwine… the Bachelor, which included the smash hit \"Pony.\" This marked his breakthrough as a major creative force in music production.",
  },
  {
    num: "02",
    tag: "First",
    title: "First Emergence of His Signature Style",
    sub: "Aaliyah · One in a Million · 1996",
    body: "Later that same year, Timbaland fully showcased his distinct, futuristic beat style on Aaliyah's One in a Million, reshaping R&B's sound with syncopated rhythms and avant-garde textures.",
  },
  {
    num: "03",
    tag: "Only",
    title: "Only Producer Who Crossed Genres Seamlessly",
    sub: "R&B · Hip-Hop · Pop",
    body: "He helped launch and define major artists across R&B, hip-hop, and pop, from Missy Elliott and Aaliyah to Ginuwine, Justin Timberlake, Nelly Furtado, and Madonna. He blurred genre boundaries in a way few others have, making him uniquely versatile and consistently influential.",
  },
  {
    num: "04",
    tag: "Only",
    title: "Only Solo Single to Hit #1 on Billboard",
    sub: "\"Give It to Me\" · 2007",
    body: "\"Give It to Me\" (featuring Justin Timberlake and Nelly Furtado) is, to date, his only solo single to reach #1 on the US Billboard Hot 100.",
  },
  {
    num: "05",
    tag: "Only",
    title: "Only Producer to Win a Webby for Breaking the Internet",
    sub: "Verzuz",
    body: "Timbaland, with Swizz Beatz and DJ D-Nice, won a Webby Award for Special Achievement, \"Break the Internet,\" for their part in Verzuz: a rare recognition of his digital-era influence.",
  },
  {
    num: "06",
    tag: "First",
    title: "First to Make Abstract, Everyday Sounds Mainstream",
    sub: "Clicks · Stutters · Ambience",
    body: "He didn't just sample; he built sounds from scratch, clicks, animal noises, stutters, and ambient elements. A testimony to his boundary-pushing creativity on records like \"One in a Million\" and \"The Rain (Supa Dupa Fly).\"",
  },
];

export default function FirstsAndOnlys() {
  return (
    <section id="firsts-and-onlys" className="relative bg-[#0d0d0d] py-24 md:py-36 border-t border-white/10" data-testid="firsts-onlys-section">
      <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 15% 15%, rgba(79, 176, 74,0.12), transparent 55%)" }} />
      <div className="relative z-10 max-w-[1600px] mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl mb-14 md:mb-20">
          <p className="overline text-gold mb-6">Firsts & Onlys</p>
          <h2 className="headline text-5xl md:text-7xl text-white mb-6">The Trailblazer Record</h2>
          <p className="font-body text-white/55 text-lg">
            Some milestones can never be repeated. These are the moments where Timbaland was the first, or the only, to do it.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {firsts.map((f, i) => (
            <motion.div
              key={f.num}
              data-testid={`first-only-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
              className="group relative bg-[#0d0d0d] p-8 md:p-10 hover:bg-white/[0.03] transition-colors flex flex-col"
            >
              <div className="flex items-center justify-between mb-6">
                <span className="font-display font-700 text-5xl md:text-6xl text-white/[0.08] group-hover:text-gold/30 transition-colors">
                  {f.num}
                </span>
                <span
                  className={`font-display uppercase tracking-[0.18em] text-[0.6rem] px-3 py-1 rounded-full border ${
                    f.tag === "Only" ? "text-gold border-gold/50" : "text-white/70 border-white/25"
                  }`}
                >
                  {f.tag}
                </span>
              </div>
              <h3 className="font-editorial italic text-2xl md:text-[1.7rem] leading-tight text-white mb-2">{f.title}</h3>
              <p className="font-display uppercase tracking-[0.14em] text-[0.66rem] text-gold mb-5">{f.sub}</p>
              <p className="font-body text-white/55 text-[0.95rem] leading-relaxed">{f.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
